import api from "./api";

/**
 * Fires GET /api/dedupe/check with a whitelisted set of query params.
 * Returns `{ hasMatches: boolean, matches: {contacts, leads, deals} }`.
 * Callers that don't care about failure can safely ignore rejections —
 * failing dedupe should NEVER block the actual create.
 */
export async function checkDuplicates(params) {
  const query = {};
  for (const [k, v] of Object.entries(params || {})) {
    if (v != null && v !== "" && v !== undefined) query[k] = v;
  }
  if (!query.entity_type) throw new Error("entity_type is required");
  try {
    const { data } = await api.get("/dedupe/check", { params: query });
    return { hasMatches: !!data.has_matches, matches: data.matches || { contacts: [], leads: [], deals: [] } };
  } catch {
    // Don't block create on a dedupe failure.
    return { hasMatches: false, matches: { contacts: [], leads: [], deals: [] } };
  }
}
